export default {
  presenter: 'holecek',
  title: 'PXE, salt, initrd - automatizace síťové instalace',
  subtitle: 'pokročilí/zkušení administrátoři/programátoři',
  text: `
PXE boot je jednou z cest, jak jednoduše instalovat systém na větší počet zařízení na dálku.
Protože ne všechna zařízení jsou stejná, často se musí systém nějak vypořádat s různými konfiguracemi
hardware, ale i software dle určení zařízení.  
Přibalením salt podpory do boot image pro PXE boot se elegantně vyhneme různým hackům a nestandardní
vzdálené údržbě.  
Salt minion v boot image však není konec, ale naopak začátek této přednášky, kde vám představím princip
a možnosti našeho salt-based PXE řešení.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/holecek-pxe.js